import { useInstantSearch } from 'react-instantsearch-core';

import type { ResponsiveColorsType } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { useRouter } from '@/hooks/useRouter';
import { useRefNumberContext } from '@/providers/RefNumberProvider/RefNumberProviderContext';
import { theme } from '@/theme/index';

import * as Sc from '../FiltersApplied/FiltersApplied.styles';
import * as S from './FilterAppliedButton.styles';

interface FilterAppliedButtonProps {
  attribute: string;
  item: string;
  name: string;
}

export const FilterAppliedButton = ({
  attribute,
  item,
  name,
}: FilterAppliedButtonProps) => {
  const { query } = useRouter();
  const { indexUiState, setIndexUiState } = useInstantSearch();
  const { setRefNumber } = useRefNumberContext();

  const clearFilters = () => {
    const newQuery = { ...query };
    Object.keys(newQuery).forEach((key) => {
      if (newQuery[key] === item) {
        delete newQuery[key];
        if (key === 'objectID') {
          setRefNumber('');
        }
      }
    });

    const updatedRefinements = (
      indexUiState.refinementList?.[attribute] || []
    ).filter((refinement: string) => refinement !== item);

    setIndexUiState({
      ...indexUiState,
      refinementList: {
        ...indexUiState.refinementList,
        [attribute]: updatedRefinements,
      },
      page: 1,
    });
  };

  return (
    <S.Button onClick={clearFilters}>
      <Flex alignItems='center' gridGap={1} justifyContent='space-between'>
        {name}
        <Sc.CloseIcon
          color={theme.colors.almostBlack as ResponsiveColorsType}
          name='close'
          size='m'
          variant='regular'
        />
      </Flex>
    </S.Button>
  );
};
